import React, { useState } from "react";
import NavBar from "../NavBar";
import SponsorsMobileDropdown from "./SponsorsPageDropdown";
import background1 from "../../images/background_sponsors.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Feup from '../../images/sponsors/feup.png';
import DeMec from '../../images/sponsors/demec.png';
import IPDJ from '../../images/sponsors/ipdj.png';
import Inegi from '../../images/sponsors/inegi.png';
import Catana from '../../images/sponsors/catana.png';
import GrupoPR from '../../images/sponsors/grupo-pr.png';
import Mystic from '../../images/sponsors/mystic.png';
import Palbit from '../../images/sponsors/palbit.svg';
import Quantal from '../../images/sponsors/quantal.png';
import Neem from '../../images/sponsors/neem.svg';
import JuniFeup from '../../images/sponsors/JuniFEUP.png';
import AEFeup from '../../images/sponsors/aefeup.png';
import Elio from '../../images/sponsors/elio.png';
import Coficab from '../../images/sponsors/coficab.png';
import Maximoferta from '../../images/sponsors/maximoferta.png';
import Elergone from '../../images/sponsors/elergone.svg';
import EpsilonComposites from '../../images/sponsors/epsilon.png';
import Mauser from '../../images/sponsors/mauser.png';
import DCTech from '../../images/sponsors/4dc-tech.png';
import Polipop from '../../images/sponsors/polipop.png';
import EasyComposites from '../../images/sponsors/easy-composites.png';
import Igus from '../../images/sponsors/igus.png';
import Ultraflex from '../../images/sponsors/ultraflex.png';
import Bcomp from '../../images/sponsors/bcomp.png';
import Rebelco from '../../images/sponsors/rebelco.png';
import Inductiva from '../../images/sponsors/inductiva.png';
import Orca3D from '../../images/sponsors/orca-3d.webp';
import Cadence from '../../images/sponsors/cadence.webp';
import Chuvitex from '../../images/sponsors/chuvitex.png';
import Cadflow from '../../images/sponsors/cadflow.png';
import NKT from '../../images/sponsors/nkt.png';
import Anodfarbe from '../../images/sponsors/anodfarbe.png'; 
import Invicta3D from '../../images/sponsors/invicta3d.png';
import Navicork from '../../images/sponsors/navicork.png';
import Ceiia from '../../images/sponsors/ceiia.png';
import YCP from '../../images/sponsors/ycp.png';
import Olika from '../../images/sponsors/olika.png';
import DontWorry from '../../images/sponsors/dont-worry-douro.png';
import LojaFerragens from '../../images/sponsors/lojaFerragens.png';
import Movella from '../../images/sponsors/movella.png';

const tierBgColors = {
  Platinum: "#8C5A5A",
  Gold:     "#C3B67E",
  Silver:   "#8D8B8B",
  Bronze:   "#A2917E",
  General:  "#62727D",
  Software: "#74C365",
  Institutional: "#FFFFFF",
};

const SponsorsPage = () => {
  const [activeSection, setActiveSection] = useState("Platinum");

  const sponsors = {
    Platinum: [
      { name: "Catana", link: 'https://www.catanagroup.com/en/', logo: Catana },
      { name: "Grupo PR", link: 'https://www.prgrupo.com/pt/', logo: GrupoPR },
      {name: "Mystic Invest", link: 'https://www.mysticinvest.com/', logo: Mystic},
      { name: "Palbit", link: 'https://www.palbit.pt/pt', logo: Palbit }
    ],
    Gold: [
      { name: "Quantal", link: 'https://www.quantal.pt/', logo: Quantal },
      { name: "Coficab", link: 'https://www.coficab.com/', logo: Coficab },
      { name: "Elio Kayaks", link: 'http://www.eliokayaks.com/', logo: Elio },
      { name: "Maximoferta", link: 'https://www.maximoferta.com/pt/', logo: Maximoferta },
      { name: "Movella", link: 'https://www.movella.com/', logo: Movella }
    ],
    Silver: [
      { name: "Mauser.pt", link: "https://www.mauser.pt/", logo: Mauser },
      { name: "Elergone Energia", link: "https://elergone.pt/", logo: Elergone },
      { name: "Epsilon Composites", link: "https://www.epsiloncomposites.com/", logo: EpsilonComposites },
      { name: "4DC Tech", link: "#", logo: DCTech },
      { name: "Inegi", link: 'https://www.inegi.pt/pt/?', logo: Inegi }
    ],
    Bronze: [
      { name: "Polipop", link: "https://polipop.pt/", logo: Polipop },
      { name: "NKT", link: "https://www.nkt.com/", logo: NKT },
      { name: "Anodfarbe", link: "https://anodfarbe.com/en/", logo: Anodfarbe }
    ],
    General: [
      { name: "Easy Composites", link: "https://www.easycomposites.eu/", logo: EasyComposites },
      { name: "Igus", link: "https://www.igus.pt/", logo: Igus },
      { name: "Ultraflex", link: "https://ultraflexgroup.it/", logo: Ultraflex },
      { name: "Bcomp", link: "https://bcomp.ch/", logo: Bcomp },
      { name: "Rebelco", link: "https://rebelco.pt/", logo: Rebelco },
      { name: "Chuvitex", link: "https://www.chuvitex.com/", logo: Chuvitex },
      { name: "Invicta3D", link: "https://invicta3d.pt/", logo: Invicta3D },
      { name: "Ceiia", link: "https://www.ceiia.com/", logo: Ceiia },
      { name: "Navicork", link: "https://navicork.com/", logo: Navicork },
      { name: "Olika3D", link: "https://www.olika.de/", logo: Olika },
      { name: "Don't Worry Douro", link: "https://dontworrydouro.com/", logo: DontWorry },
      { name: "Loja das Ferragens", link: "https://lojadasferragens.pt/", logo: LojaFerragens },
    ],
    Software: [
      { name: "Inductiva", link: "https://inductiva.ai/", logo: Inductiva },
      { name: "Orca3D", link: "https://orca3d.com/", logo: Orca3D },
      { name: "Cadence", link: "https://www.cadence.com/", logo: Cadence },
      { name: "Cadflow", link: "https://www.cadflow.pt/", logo: Cadflow }, 
    ],
    Institutional: [
      { name: "FEUP", link: 'https://www.fe.up.pt/', logo: Feup },
      { name: "DEMEC", link: 'https://sigarra.up.pt/feup/en/uni_geral.unidade_view?pv_unidade=4', logo: DeMec },
      { name: "NEEM", link: 'https://www.neemfeup.pt/', logo: Neem },
      { name: "IPDJ", link: 'https://ipdj.gov.pt/', logo: IPDJ },
      { name: "JuniFEUP", link: 'https://www.junifeup.pt/', logo: JuniFeup },
      { name: "AEFEUP", link: 'https://aefeup.pt/', logo: AEFeup },
      { name: "Yate Clube do Porto", link: 'https://ycporto.pt/', logo: YCP },
    ]
  };

  const tierColors = {
    Platinum: "text-platinum",
    Gold: "text-gold",
    Silver: "text-silver",
    Bronze: "text-bronze",
    General: "text-general",
    Software: "text-software",
    Institutional: "text-institutional",
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "50px",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, centerPadding: "30px", centerMode: true } },
      { breakpoint: 768, settings: { slidesToShow: 2, centerPadding: "20px", centerMode: true } },
      { breakpoint: 480, settings: { arrows: false, slidesToShow: 2, centerPadding: "20px", centerMode: true } },
    ],
  };

  const hexToRgba = (hex, alpha = 1) => {
    const bigint = parseInt(hex.replace(/^#/, ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const gradientString = activeSection === "Institutional"
  ? "linear-gradient(90deg, rgba(128, 128, 128, 0.8), rgba(128, 128, 128, 0.2))"
  : `linear-gradient(90deg, ${hexToRgba(tierBgColors[activeSection], 0.8)}, ${hexToRgba(tierBgColors[activeSection], 0.2)})`;

  return (
    <div className="w-full">
      <NavBar activeSection="sponsors" />

      {/* Hero Section */}
      <div
        className="relative w-full h-screen bg-cover bg-center flex items-center justify-left px-4 sm:px-8 bg-gradient-to-r from-gray-500 to-gray-300"
        style={{ backgroundImage: `url(${background1})`, marginTop: "100px" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-30" />
        <div className="relative z-10 text-center pl-6 sm:pl-32 pb-24 sm:pb-48">
          <h1 className="leading-tight font-bold">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-5 items-center sm:items-start">
              <span className="text-mainBlue text-4xl sm:text-5xl md:text-9xl">Meet</span>
              <span className="text-mainBlue text-4xl sm:text-5xl md:text-9xl mt-2 sm:mt-9">our</span>
            </div>
            <span className="block text-white text-5xl sm:text-6xl md:text-9xl mt-4 sm:mt-6">Sponsors</span>
          </h1>
        </div>
      </div>

      {/* Desktop Navigation & Carousel */}
      <div
        className="w-full transition-all duration-500 ease-in-out pt-5 hidden md:block"
        style={{ background: gradientString }}
      >
        {/* Tier Buttons */}
        <div className="flex flex-wrap justify-center items-center space-x-4 sm:space-x-12">
          {Object.keys(sponsors).map((tier) => (
            <button
            key={tier}
            onClick={() => setActiveSection(tier)}
            className={`
              transition-all duration-500 ease-in-out mb-2 cursor-pointer
              ${
                activeSection === tier
                  ? `${tierColors[tier]} text-3xl sm:text-6xl font-bold opacity-100`
                  : "text-gray-100 text-lg sm:text-xl opacity-60 hover:opacity-100 font-light"
              }
            `}
          >
            {tier}
          </button>
          ))}
        </div>
        <div className="mx-auto w-full sm:w-[90%] md:w-[80%] lg:w-[80%] py-10 sm:py-20">
          {sponsors[activeSection].length > sliderSettings.slidesToShow ? (
            <Slider {...sliderSettings}>
              {sponsors[activeSection].map((sponsor, idx) => (
                <div key={idx} className="flex justify-center items-center mt-10 px-2 text-center">
                  <a href={sponsor.link} target="_blank" rel="noreferrer" className="flex justify-center items-center w-full max-w-[250px] sm:max-w-[300px] aspect-[5/4] overflow-hidden bg-white bg-opacity-50 hover:bg-opacity-30 rounded-lg shadow-md">
                    <img src={sponsor.logo} alt={sponsor.name} className="w-10/12 object-contain object-center" />
                  </a>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="flex flex-wrap justify-center items-center mt-10 px-2 gap-8">
              {sponsors[activeSection].map((sponsor, idx) => (
                <a key={idx} href={sponsor.link} target="_blank" rel="noreferrer" className="flex justify-center items-center w-full max-w-[250px] sm:max-w-[300px] aspect-[5/4] overflow-hidden bg-white bg-opacity-50 hover:bg-opacity-30 rounded-lg shadow-md">
                  <img src={sponsor.logo} alt={sponsor.name} className="w-10/12 object-contain object-center" />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Mobile Dropdown Navigation */}
      <SponsorsMobileDropdown
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        tierColors={tierColors}
        sponsors={sponsors}
        gradientString={gradientString}
      />

      {/* Mobile Sponsors List */}
      <div 
        className="flex flex-col md:hidden justify-center items-center px-4 pb-10"
        style={{ background: gradientString }}
      >

        {sponsors[activeSection].length > 0 ? (
          sponsors[activeSection].map((sponsor, idx) => (
            <div key={idx} className="flex justify-center items-center mt-10 px-2 text-center">
              <a href={sponsor.link} target="_blank" rel="noreferrer" className="flex justify-center items-center w-[250px] sm:w-[300px] aspect-[5/4] overflow-hidden bg-white bg-opacity-50 hover:bg-opacity-30 rounded-lg shadow-md">
                <img src={sponsor.logo} alt={sponsor.name} className="w-10/12 object-contain object-center" />
              </a>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No sponsors in this category.</p>
        )}
      </div>

    </div>
  );
};

export default SponsorsPage;
